import type { ComponentProps } from "react";

export function MarkdownCode({ className, children }: ComponentProps<"code">) {
	const isBlock = className?.includes("language-") || String(children).includes("\n");
	if (isBlock) {
		return <code className="font-mono">{children}</code>;
	}
	return <code className="rounded-2 bg-line-1 px-1 py-0.5 text-caption">{children}</code>;
}
